export const boardKpiTour = {
  key: "boardKpi",
  version: 1,
  getSteps: (t) => [
    {
      target: '[data-tour="board-kpi-card"]',
      content: t("Tour_BoardKpi_Card"),
      placement: "top",
      disableBeacon: true,
    },
    {
      target: '[data-tour="board-kpi-chart"]',
      content: t("Tour_BoardKpi_Chart"),
      placement: "top",
    },
    {
      target: '[data-tour="board-kpi-goal"]',
      content: t("Tour_BoardKpi_Goal"),
      placement: "bottom",
    },
  ],
};
